import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getMappedProductReviewForm } from "containers/creditReview/details/tabs/executiveSummary/sections/productReview/getMappedProductReviewForm";
import { getErrorMessage } from "helpers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateProductReviewMutation = ({ creditReviewId, onSuccess }) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			formValues,
			setActionFormState,
		}: {
			formValues: { [key: string]: any };
			setActionFormState: any;
		}) => {
			return creditReviewDetailsService.updateProductReview(
				creditReviewId,
				getMappedProductReviewForm(formValues),
			);
		},

		{
			onSuccess(_result, { setActionFormState }) {
				onSuccess();
				setActionFormState(false);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateProductReviewMutation;
